import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface NumberWidgetProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  min?: number;
  max?: number;
  step?: number;
  helpText?: string;
}

export const NumberWidget: React.FC<NumberWidgetProps> = ({
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  description,
  min,
  max,
  step = 1,
  helpText
}) => {
  const id = `number-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <div className={wt.container}>
      <div className={wt.labelRow}>
        <label className={wt.label} htmlFor={id}>
          {label}
          {required && <span className={wt.required}>*</span>}
        </label>
        {helpText && <HelpTooltip helpText={helpText} />}
      </div>
      {description && <p className={wt.description}>{description}</p>}
      <input
        id={id}
        type="number"
        value={value ?? ''}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        aria-label={label}
        className={`${wt.numberInput} ${error ? wt.inputError : ''}`}
      />
      {(min !== undefined || max !== undefined) && (
        <p className={wt.hint}>Range: {min ?? '∞'} – {max ?? '∞'}</p>
      )}
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default NumberWidget;
